import { ComponentAPI } from '@philips-emr/tws-core';

class RequestDataCollectorAPI extends ComponentAPI {}

export default RequestDataCollectorAPI;
